import { render, staticRenderFns } from "./examineProfit.vue?vue&type=template&id=87e9f8ee&scoped=true"
import script from "./examineProfit.vue?vue&type=script&lang=js"
export * from "./examineProfit.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/myGuZhi.css?vue&type=style&index=0&id=87e9f8ee&prod&scoped=true&lang=css&external"
import style1 from "./examineProfit.vue?vue&type=style&index=1&id=87e9f8ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e9f8ee",
  null
  
)

export default component.exports